export const START_GAME_CODE_CHECK = 'game_code/START_GAME_CODE_CHECK'
export const GAME_CODE_CHECK_FAIL = 'game_code/GAME_CODE_CHECK_FAIL'
export const GAME_CODE_CHECK_SUCCESS = 'game_code/GAME_CODE_CHECK_SUCCESS'
export const START_GAME = 'game_code/START_GAME'
export const GAME_FAIL = 'game_code/GAME_FAIL'
export const GAME_SUCCESS = 'game_code/GAME_SUCCESS'
export const GET_PLAYLIST_AND_AD_CAMP_FAIL = 'game_code/GET_PLAYLIST_AND_AD_CAMP_FAIL'
export const GET_PLAYLIST_AND_AD_CAMP = 'game_code/GET_PLAYLIST_AND_AD_CAMP'
export const GET_PLAYLIST_AND_AD_CAMP_SUCCESS = 'game_code/GET_PLAYLIST_AND_AD_CAMP_SUCCESS'
export const GET_PLAYLIST_FAIL = 'game_code/GET_PLAYLIST_FAIL'
export const GET_PLAYLIST = 'game_code/GET_PLAYLIST'
export const GET_PLAYLIST_SUCCESS = 'game_code/GET_PLAYLIST_SUCCESS'
export const GUESS_CHECKING = 'guess/GUESS_CHECKING'
export const GUESS_CHECK_FAIL = 'guess/GUESS_CHECK_FAIL'
export const GUESS_CHECK_SUCCESS = 'guess/GUESS_CHECK_SUCCESS'
export const POSTING = 'games/POSTING'
export const POSTING_FAIL = 'POSTING_FAIL'
export const SOLO_GAME_FAIL = 'SOLO_GAME_FAIL'
export const START_SOLO_GAME = 'START_SOLO_GAME'
export const SOLO_GAME_SUCCESS = 'SOLO_GAME_SUCCESS'
export const UPDATE_REQUEST = 'UPDATE_REQUEST'
export const UPDATE_REQUEST_FAIL = 'UPDATE_REQUEST_FAIL'
export const UPDATE_REQUEST_SUCCESS = 'UPDATE_REQUEST_SUCCESS'
export const STARTING_ROUND = 'STARTING_ROUND'
export const STARTING_ROUND_FAIL = 'STARTING_ROUND_FAIL'
export const STARTING_ROUND_SUCCESS = 'STARTING_ROUND_SUCCESS'
export const LOADING_SONG = 'LOADING_SONG'
export const LOADING_SONG_FAIL = 'LOADING_SONG_FAIL'
export const LOADING_SONG_SUCCESS = 'LOADING_SONG_SUCCESS'
export const ACTIVE_SONG = 'ACTIVE_SONG'
export const ACTIVE_SONG_FAIL = 'ACTIVE_SONG_FAIL'
export const ACTIVE_SONG_SUCCESS = 'ACTIVE_SONG_SUCCESS'
export const GAME_DATA_FAIL = 'GAME_DATA_FAIL'
export const GAME_DATA_SUCCESS = 'GAME_DATA_SUCCESS'
export const GET_GAME_DATA = 'GET_GAME_DATA'
export const STARTING_NEW_GAME = 'STARTING_NEW_GAME'
export const STARTING_NEW_GAME_FAIL = 'STARTING_NEW_GAME_FAIL'
export const STARTING_NEW_GAME_SUCCESS = 'STARTING_NEW_GAME_SUCCESS'
export const GET_GAME_PROFILES = 'GET_GAME_PROFILES'
export const GET_GAME_PROFILES_FAIL = 'GET_GAME_PROFILES_FAIL'
export const GET_GAME_PROFILES_SUCCESS = 'GET_GAME_PROFILES_SUCCESS'
export const UPDATING_GAME = 'UPDATING_GAME'
export const UPDATING_GAME_FAIL = 'UPDATING_GAME_FAIL'
export const UPDATING_GAME_SUCCESS = 'UPDATING_GAME_SUCCESS'
export const ADD_NEW_ROUND = 'ADD_NEW_ROUND'
export const ADD_NEW_ROUND_SUCCESS = 'ADD_NEW_ROUND_SUCCESS'
export const ADD_NEW_ROUND_FAIL = 'ADD_NEW_ROUND_FAIL'
export const GET_OPEN_SESSION_LIST = 'GET_OPEN_SESSION_LIST'
export const GET_OPEN_SESSION_LIST_SUCCESS = 'GET_OPEN_SESSION_LIST_SUCCESS'
export const GET_OPEN_SESSION_LIST_FAIL = 'GET_OPEN_SESSION_LIST_FAIL'
export const CLOSING_OPEN_SESSION = 'CLOSING_OPEN_SESSION'
export const CLOSING_OPEN_SESSION_FAIL = 'CLOSING_OPEN_SESSION_FAIL'
export const CLOSING_OPEN_SESSION_SUCCESS = 'CLOSING_OPEN_SESSION_SUCCESS'
export const GET_OPEN_SERIES_LIST = 'GET_OPEN_SERIES_LIST'
export const GET_OPEN_SERIES_LIST_FAIL = 'GET_OPEN_SERIES_LIST_FAIL'
export const GET_OPEN_SERIES_LIST_SUCCESS = 'GET_OPEN_SERIES_LIST_SUCCESS'
export const GET_SERIES_DETAIL = 'GET_SERIES_DETAIL'
export const CLOSING_OPEN_SERIES_SUCCESS = 'CLOSING_OPEN_SERIES_SUCCESS'
export const CLOSING_SERIES_SESSION_SUCCESS = 'CLOSING_SERIES_SESSION_SUCCESS'
export const GET_SERIES_SCORE = 'GET_SERIES_SCORE'
export const START_DEMO_GAME = 'START_DEMO_GAME'
export const RESET_GAME_CONFIGURATION = 'RESET_GAME_CONFIGURATION'
export const GET_DEMO_DATA = 'GET_DEMO_DATA'
export const START_DEMO_GAME_FROM_HEADER = 'START_DEMO_GAME_FROM_HEADER'
export const GETTING_REMOTE_DATA = 'GETTING_REMOTE_DATA'
export const GETTING_REMOTE_DATA_SUCCESS = 'GETTING_REMOTE_DATA_SUCCESS'
export const GETTING_REMOTE_DATA_FAIL = 'GETTING_REMOTE_DATA_FAIL'
export const SKIP_SONG_SUCCESS = 'SKIP_SONG_SUCCESS'
export const SKIP_SONG = 'SKIP_SONG'
export const RESET_GAME_DATA = 'RESET_GAME_DATA'
export const GET_UPDATED_DATA_AFTER_SKIP = 'GET_UPDATED_DATA_AFTER_SKIP'
export const GET_SERIES_GAMES = 'GET_SERIES_GAMES'
export const START_APPLIANCE_GAME = 'START_APPLIANCE_GAME'
export const UPDATE_APPLIANCE = 'UPDATE_APPLIANCE'
export const CREATE_GAME_FROM_HEADER = 'CREATE_GAME_FROM_HEADER'
export const RESET_SCORE = 'RESET_SCORE'
export const SEND_USERS_EMAIL = 'SEND_USERS_EMAIL'
export const RESET_GAME = 'RESET_GAME'
export const CURRENT_POINTS = 'player/CURRENT_POINTS'
export const START_GAME_IN = [
  { time: '1 minute' },
  { time: 'now!' },
  { time: 'update only' },
  { time: '30 seconds' },
  { time: '3 minutes' },
  { time: '5 minutes' },
  { time: '10 minutes' },
  { time: '15 minutes' },
]

export const TICKETS = []
for (var i = 1; i <= 20; i++) TICKETS.push({ ticket: i })

TICKETS.push({ ticket: 'SELECT' })
TICKETS.reverse()

export const SERIES_OPTIONS = ['SELECT SERIES', 'NEW SERIES']

export const OPEN_SESSION_OPTIONS = [
  { open_session: 'SELECT SESSION' },
  { open_session: 'NEW SESSION' },
  { open_session: 'LIST ACTIVE SESSIONS' },
]
export const SEND_HOST_ANSWER = 'SEND_HOST_ANSWER'
export const GAME_PLAYERS = 'GAME_PLAYERS'
export const GIFTING_DATA = 'GIFTING_DATA'
export const GAME_LEADERBOARD = 'GAME_LEADERBOARD'
export const GET_SONG_DATA = 'GET_SONG_DATA'
export const SELECTED_SONG_SKIPPED = 'SELECTED_SONG_SKIPPED'
export const ADD_FEEDBACK = 'ADD_FEEDBACK'
export const GIFT_TICKETS = 'GIFT_TICKETS'
export const GET_TRIVIA_ASSETS = 'GET_TRIVIA_ASSETS'
